module.exports = __webpack_public_path__ + "img/victory-link.badef3f9.png";